var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#FFDA44;}\n\t.st4{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M512,256c0-11.3-0.7-22.5-2.2-33.4H222.6C170.3,170.3,75,75,75,75C-25,175-25,337,75,437l147.6-147.6h287.2 C511.3,278.5,512,267.3,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.8,222.6c0.1,0.9,0.2,1.8,0.3,2.6C495,98.4,387,0,256,0C185.3,0,121.3,28.7,75,75l147.6,147.6L509.8,222.6 L509.8,222.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.8,289.4H222.6L75,437c46.3,46.3,110.3,75,181,75c131,0,239-98.4,254.2-225.2 C510.1,287.6,509.9,288.5,509.8,289.4L509.8,289.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511.8,244.8H213.2L59.8,91.4c-5,5.2-10.3,12.5-13.7,17.7l146.7,146.7L46.1,402.7c2.9,5.2,9.2,12.8,13.7,17.8 L213.2,267h298.6c0.2-3.7,0.2-7.4,0.2-11.1C512,250.9,511.9,247.2,511.8,244.8L511.8,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.2,310.6v-21.4c21.4,0,38.8-17.4,38.8-38.8c0-15.1-12.3-27.5-27.5-27.5c-10.3,0-18.7,8.4-18.7,18.7 c0,6.6,5.4,12,12,12c3.7,0,6.8-3,6.8-6.8H95c0,15.6-12.7,28.2-28.2,28.2c-18.4,0-33.4-15-33.4-33.4c0-22.1,18-40.1,40.1-40.1 c27,0,48.9,21.9,48.9,48.9C122.4,283.5,95.4,310.6,62.2,310.6L62.2,310.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/vu.6ebd4700e80193832ace52ca59aa8c69.svg";
export { ForwardRef as ReactComponent };